<template>
  <div class="ui small modal" ref="modal">
    <i class="close icon"></i>
    <div class="linkify header">
      <i class="visa icon"></i>
      {{ $t("visalink link") }}
    </div>
    <div class="image content">
      <div class="ui small image">
        <img src="/images/icons/visalink.png" style="width: 100% !important" />
      </div>
      <div class="description" style="width: 100% !important">
        <div class="ui form" ref="form">
          <div class="three fields">
            <div class="field">
              <label for="">{{ $t("profile") }}</label>
              <div class="ui selection dropdown" ref="profile_dropdown">
                <input type="hidden" name="profile" />
                <i class="dropdown icon"></i>
                <div class="default text"></div>
                <div class="menu"></div>
              </div>
            </div>
            <div class="field">
              <label for="">{{ $t("internal code") }}</label>
              <input type="text" name="internal_code" v-model="internal_code" />
            </div>
            <div class="field">
              <label for="">{{ $t("internal name") }}</label>
              <input type="text" name="internal_name" v-model="internal_name" />
            </div>
          </div>
          <div class="fields">
            <div class="eight wide field">
              <label for="">{{ $t("title") }}</label>
              <input type="text" name="title" v-model="title" />
            </div>
            <div class="four wide field">
              <label for="">{{ $t("quotas") }}</label>
              <div class="ui selection dropdown" ref="quota_dropdown">
                <input type="hidden" name="quotas" />
                <i class="dropdown icon"></i>
                <div class="default text"></div>
                <div class="menu"></div>
              </div>
            </div>
            <div class="four wide field">
              <label for="">{{ $t("quota") }}</label>
              <input type="text" name="quota" v-model="quota" />
            </div>
          </div>
          <div class="field">
            <label for="">{{ $t("social networks") }}</label>
            <div
              class="ui multiple search selection dropdown"
              ref="social_networks_dropdown"
            >
              <input type="hidden" name="social_networks" />
              <i class="dropdown icon"></i>
              <div class="default text"></div>
              <div class="menu"></div>
            </div>
          </div>
          <div class="field">
            <label for="">{{ $t("description") }}</label>
            <textarea
              name="description"
              rows="2"
              v-model="description"
            ></textarea>
          </div>
          <div class="ui error message"></div>
        </div>
      </div>
    </div>
    <div class="actions">
      <div class="ui blue icon right labeled deny button">
        <i class="remove icon"></i>
        {{ $t("close") }}
      </div>
      <div class="ui green icon right labeled button" @click="save">
        <i class="save icon"></i>
        {{ $t("save") }}
      </div>
    </div>
  </div>
</template>

<script>
import { local_api, error_toast } from "@/utils";
import { quotas } from "@/modules/visalink/quotas";

export default {
  name: "ShortioLinkModalIndex",
  components: {},
  props: { module_configuration: Object },
  computed: {},
  data() {
    return {
      profile: "",
      internal_code: "",
      title: "",
      quotas: "",
      internal_name: "",
      quota: "",
      social_networks: "",
      description: "",
      form: undefined,
    };
  },
  methods: {
    show_modal(data) {
      let vm = this;

      /**
       * get template
       */
      if (data) {
        console.log(data);
      }

      window
        .jQuery(vm.$refs.modal)
        .modal({
          onVisible() {
            /** Social networks dropdown */
            let vls = vm.module_configuration.social_networks.map((s) => {
              return { name: s.nombre, value: s.codigo };
            });
            window
              .jQuery(vm.$refs.social_networks_dropdown)
              .dropdown("setup menu", { values: vls })
              .dropdown({
                onChange(value) {
                  vm.social_networks = value;
                },
              });

            /** Quotas dropdown */
            let vls1 = quotas.map((q) => {
              return { name: vm.$t(q.name), value: q.code };
            });
            window
              .jQuery(vm.$refs.quota_dropdown)
              .dropdown("setup menu", { values: vls1 })
              .dropdown({
                onChange(value) {
                  vm.quotas = value;
                },
              });

            /** Profiles dropdown */
            let vls2 = vm.module_configuration.configuration.settings.map(
              (s) => {
                return { name: s.name, value: s.uuid };
              },
            );
            window
              .jQuery(vm.$refs.profile_dropdown)
              .dropdown("setup menu", { values: vls2 })
              .dropdown({
                onChange(value) {
                  vm.profile = value;
                },
              });
          },
          onHide() {
            vm.form.form("reset");
          },
        })
        .modal("show");

      vm.form = window.jQuery(vm.$refs.form).form({
        fields: {
          profile: ["empty"],
          internal_code: ["empty"],
          title: ["empty"],
          quotas: ["empty"],
          internal_name: ["empty"],
          quota: ["empty"],
          social_networks: ["empty"],
          description: ["empty"],
        },
      });
    },
    save() {
      let vm = this;

      let isValid = vm.form.form("validate form");
      if (isValid) {
        local_api(vm, "post", "/visalink/link/do-create", {
          p: vm.profile,
          i: vm.internal_code,
          t: vm.title,
          q: vm.quotas,
          in: vm.internal_name,
          qt: vm.quota,
          sn: vm.social_networks,
          d: vm.description,
        })
          .then(() => {
            window.jQuery(vm.$refs.modal).modal("hide");
            vm.$emit("success");
          })
          .catch((err) => {
            error_toast(err);
          });
      }
    },
    // convert() {
    //   let vm = this;

    //   local_api(vm, "post", "/shortio/link/do-convert", {
    //     u: vm.original_url,
    //   })
    //     .then((r) => {
    //       vm.shortio_url = r;
    //     })
    //     .catch((err) => {
    //       error_toast(err);
    //     });
    // },
    // load_configuration() {
    //   let vm = this;
    //   local_api(vm, "post", "/visalink/configuration/do-get")
    //     .then((conf) => {
    //       if (conf) {
    //         if (conf.settings) {
    //           let vls = conf.settings.map((s) => {
    //             return { name: s.name, value: s.uuid };
    //           });

    //           window
    //             .jQuery(vm.$refs.profile_dropdown)
    //             .dropdown("setup menu", { values: vls })
    //             .dropdown({
    //               onChange(value) {
    //                 vm.profile = value;
    //               },
    //             });
    //         }
    //       }
    //     })
    //     .catch((err) => {
    //       error_toast(err);
    //     });

    //   /** Social network list */
    //   local_api(vm, "post", "/visalink/link/do-get-social-networks")
    //     .then((sn) => {
    //       let vls = sn.map((s) => {
    //         return { name: s.nombre, value: s.codigo };
    //       });

    //       window
    //         .jQuery(vm.$refs.social_networks_dropdown)
    //         .dropdown("setup menu", { values: vls })
    //         .dropdown({
    //           onChange(value) {
    //             vm.social_networks = value;
    //           },
    //         });
    //     })
    //     .catch((err) => {
    //       error_toast(err);
    //     });
    // },
  },
  mounted() {
    // let vm = this;
    // window.jQuery(this.$refs.form).form({
    //   fields: {
    //     name: ["empty"],
    //   },
    // });
    // vm.load_configuration();
  },
  watch: {},
  updated: function() {},
};
</script>
